/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {SpeciesModal} from "./SpeciesModal";

export const AddSpeciesModal = (props) => {
	return <SpeciesModal
		{...props}
		title="Add Species"
		summaryComponent={null}
		hiddenFields={[
			'SpeciesRequest_observedProjectContextNodeId',
			'SpeciesRequest_observedDate',
			'SpeciesRequest__speciesListIds',
			'SpeciesRequest_requesterNotes',
			'SpeciesRequest_reviewerNotes',

			'SpeciesRequest_requested',
			'SpeciesRequest_requestedByUserId',
			'SpeciesRequest_speciesRequestSourceId',
			'SpeciesRequest_reviewed',
			'SpeciesRequest_reviewedByUserId',
			'SpeciesRequest__speciesListIds',
		]}
		confirmationButtonMessage="Add"
	/>;
}